import React, { memo } from "react";
import AerosNode from "./AerosNode";

const link = process.env.REACT_APP_BACKEND_URL;

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="img" selected={selected} isConnectable={isConnectable}>
    <img src={`${link}/public/${data.url}`} alt="" style={{ width: "100%", borderRadius: 8, display: "block" }} />
  </AerosNode>
));
